import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    margin: 10px 10px 0px 10px;
    padding: 10px 10px 15px 17px;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const Name = styled.div`
    font-size: 16px;
    font-weight: bold;
`;

const FileSize = styled.div`
    font-size: 12px;
`;

type ExportOptionProps = {
    name: string;
    fileSize: string;
    onDownload?: () => void;
};

function ExportOption({ name, fileSize, onDownload }: ExportOptionProps) {
    return (
        <Container>
            <Header>
                <Name>{name}</Name>
                <Button icon={<DownloadOutlined />} onClick={onDownload} />
            </Header>
            <FileSize>
                <b>File Size:</b> {fileSize}
            </FileSize>
        </Container>
    );
}

export default observer(ExportOption);
